import { useFormField } from '@calendly/form';
import { usePrevious } from '@calendly/hooks';
import classNames from 'classnames';
import { useCallback, useMemo, useEffect, forwardRef } from 'react';
import { useBooleanState } from 'hooks/useBooleanState';
import { EditView } from './edit_view';
import { NormalView } from './normal_view';
const containerIsInvalidCss = "c1khdtgz";
const containerIsEditModeCss = "ccl8t79";
const containerCss = "c1rlnadi";
const Container = forwardRef((props, ref) => {
  const {
    isInvalid,
    isEditMode,
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} data-testid="selected-tag" data-container={`invitee-email-${props.isInvalid ? 'invalid' : 'valid'}`} className={classNames(containerCss, {
    [containerIsInvalidCss]: isInvalid,
    [containerIsEditModeCss]: isEditMode
  }, props.className)} />;
});
export const TagView = ({
  className,
  name,
  onDelete,
  tagInputRef,
  onChangeValue
}) => {
  const [isEditMode, setEditView, setNormalView] = useBooleanState(false);
  const [{
    value = ''
  }, {
    error = []
  }] = useFormField({
    name
  });
  const prevValue = usePrevious(value);
  const isInvalid = useMemo(() => !!error.length, [error]);
  useEffect(() => {
    if (prevValue && prevValue !== value) {
      onChangeValue(name);
    }
    if (!value.length) {
      onDelete();
    }
  }, [prevValue, value, onChangeValue, onDelete, name]);
  const handleDelete = useCallback(() => {
    onDelete();
    tagInputRef.current.focus();
  }, [onDelete, tagInputRef]);
  return <Container isEditMode={isEditMode} className={className} isInvalid={isInvalid}>
      {isEditMode ? <EditView name={name} toggleView={setNormalView} /> : <NormalView name={name} email={value} onDelete={handleDelete} toggleView={setEditView} />}
    </Container>;
};

require("./tag_view.wyw-in-js.css!=!../../../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./tag_view.js");